<template>
  <div id="projectClose" element-loading-background="rgba(255, 255, 255, 0.4)">
    <p class="processword" v-if="approvalprocessing" style="color: #f11b1b;font-size: 16px;text-align: center;margin-bottom:">Application approval in progress.</p>
    <el-form :model="closeForm" ref="closeForm" label-width="260px">
      <div v-if="page !== 'toDo' && canEdit && majorProjectLevel && majorProjectLevel !== 4" style="padding-bottom: 5px;">
        <el-button type="primary" size="small" v-if="closeType === 2" @click="closeType = 1">Project Closure</el-button>
        <el-button type="primary" size="small" v-if="closeType === 1" @click="closeType = 2">Exception Closure</el-button>
      </div>
      <div v-if="closeType === 2" style="padding: 5px 0 10px 0; color: #606266; font-size: 14px; font-weight: bold; line-height: 25px">
        <i class="el-icon-warning-outline" style="color: #ffa500; font-size: 18px; margin-top: 2px;"></i>
        After the project application exception closure is approved, the customer satisfaction rate and market satisfaction survey will not be initiated.
      </div>
      <el-collapse v-model="activeNames">
			  <el-collapse-item name="1">
          <template slot="title" v-if="closeType === 1">
            Satisfaction Survey Information<span class="star">*</span>
          </template>
          <el-row>
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Name:" prop="projectName">
                <el-input  v-model="closeForm.projectName" disabled/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Duration:" prop="projectDuration" :rules="[{ required: majorProjectLevel && majorProjectLevel !== 4, message: 'Please select' }]">
                <el-date-picker
                  v-model="closeForm.projectDuration"
                  type="daterange"
                  range-separator="-"
                  start-placeholder=""
                  end-placeholder=""
                  value-format="yyyy-MM-dd"
                  :disabled="!canEdit"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="closeType === 1">
            <el-col :xs="24" :md="12">
              <el-form-item label="Customer Name:" prop="customerName" :rules="[{ required: majorProjectLevel && majorProjectLevel !== 4, message: 'Please input' }]">
                <el-input  v-model="closeForm.customerName" :disabled="!canEdit" clearable placeholder="Please input" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12">
              <el-form-item label="Customer Phone Number:" prop="customerPhoneNumber" :rules="[{ required: majorProjectLevel && majorProjectLevel !== 4, message: 'Please input' }]">
                <el-input  v-model="closeForm.customerPhoneNumber" :disabled="!canEdit" clearable placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="closeType === 1">
            <el-col :xs="24" :md="12">
              <!-- <el-form-item label="Customer Mail:" prop="customerMail" :rules="[{ required: true, message: 'Please input' }]">
                <el-input  v-model="closeForm.customerMail" :disabled="!canEdit" clearable placeholder="Please input" />
              </el-form-item> -->
              <el-form-item 
                label="Customer Mail:" 
                prop="customerMail" 
                :rules="[
                  { required: majorProjectLevel && majorProjectLevel !== 4, message: 'Please input' },
                  { validator: validateEmail, trigger: 'blur' }
                ]"
              >
                <el-input 
                  v-model="closeForm.customerMail" 
                  :disabled="!canEdit"
                  clearable
                  placeholder="Please input"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12">
              <el-form-item label="Market Contact Person:" prop="marketPersonnelNo" :rules="[{ required: false, message: 'Please input' }]">
                <el-select
                  v-model="closeForm.marketPersonnelNo"
                  clearable
                  filterable
                  remote
                  placeholder="Please input"
                  :remote-method="value => remoteMethod('marketUserList', value)"
                  @change="changeMarketUser"
                  :disabled="!canEdit"
                >
                  <el-option v-for="(item, index) in marketUserList" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :md="12">
              <el-form-item label="Market Personnel No:" prop="marketNo" :rules="[{ required: true, message: 'Please input' }]">
                <el-input clearable v-model="closeForm.marketNo" maxlength="255" placeholder="Please input" />
              </el-form-item>
            </el-col> -->
            <!-- <el-col :xs="24" :md="12">
              <el-form-item label="Market Personnel Phone Number:" prop="marketPersonnelPhoneNumber" :rules="[{ required: true, message: 'Please input' }]">
                <el-input clearable v-model="closeForm.marketPersonnelPhoneNumber" :disabled="!canEdit" maxlength="255" placeholder="Please input" />
              </el-form-item> 
            </el-col> -->
          </el-row>
          <el-row v-if="closeType === 1">
            <el-col :xs="24" :md="12">
              <!-- <el-form-item label="Market Contact Person Mail:" prop="marketContactPersonMail" :rules="[{ required: true, message: 'Please input' }]">
                <el-input  v-model="closeForm.marketContactPersonMail" :disabled="!canEdit" clearable placeholder="Please input" />
              </el-form-item> -->
              <el-form-item 
                label="Market Contact Person Mail:" 
                prop="marketContactPersonMail" 
                :rules="[
                  { required: majorProjectLevel && majorProjectLevel !== 4, message: 'Please input' },
                  { validator: validateEmail, trigger: 'blur' }
                ]"
              >
                <el-input 
                  v-model="closeForm.marketContactPersonMail" 
                  :disabled="!canEdit"
                  clearable
                  placeholder="Please input"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12">
              <el-form-item label="Should the satisfaction survey be initiated:" prop="satisfactionSurveyFlag" :rules="[{ required: true, message: 'Please select' }]">
                <el-select
                  v-model="closeForm.satisfactionSurveyFlag"
                  placeholder="Please select"
                  :disabled="!canEdit || (majorProjectLevel && majorProjectLevel === 4)"
                >
                  <el-option v-for="(item, index) in yesOrNoBo" :key="index" :label="item.name" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12" v-if="closeForm.satisfactionSurveyFlag === false">
              <el-form-item label="Reason:" prop="satisfactionRemark" :rules="[{ required: majorProjectLevel && majorProjectLevel !== 4, message: 'Please select' }]">
                <el-input
                  type="textarea"
                  clearable
                  v-model="closeForm.satisfactionRemark"
                  :disabled="!canEdit"
                  maxlength="500"
                  :rows="3"
                  placeholder="Please describe the reasons for not initiating the satisfaction survey. After approval, the satisfaction survey will not be initiated."
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="closeType === 2">
            <el-col :xs="24" :md="12" style="padding-bottom: 20px">
              <el-form-item label="Project Exception Closure Reasons:" prop="description" :rules="[{ required: true, message: 'Please input' }]">
                <el-input type="textarea" show-word-limit clearable v-model="closeForm.description" :disabled="!canEdit" maxlength="500" :rows="3" placeholder="Please input, maximum 500 characters" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Closed Remark:" prop="projectClosedRemark" :rules="[{ required: false, message: 'Please input' }]">
                <el-input type="textarea" clearable v-model="closeForm.projectClosedRemark" :disabled="!canEdit" maxlength="200" :rows="3" placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
			  <el-collapse-item name="2" v-if="closeType === 1">
          <template slot="title">
            Project Document Upload<span class="star" v-if="majorProjectLevel && majorProjectLevel !== 4">*</span>
          </template>
          <el-row>
            <!-- <el-col :xs="24" :md="12">
              <el-form-item label="Implementation Solution:" prop="file1" :rules="[{ required: true, message: 'Please upload' }]">
                <el-upload
                  class="upload-demo"
                  :action="this.$store.state.islhurl + 'projectFile/upload'"
                  :before-upload="value => beforeUpload(value, 11, 'fileList1')"
                  :limit="1"
                  :file-list="fileList1"
                  :on-remove=" value => handleRemove('fileList1')"
                  :before-remove="beforeRemove"
                  :on-exceed="handleExceed"
                  :on-preview="handlePreview"
                  v-model="closeForm.file1"
                >
                  <el-button size="small" type="primary" :disabled="!canEdit">Upload</el-button>
                </el-upload>
              </el-form-item>
            </el-col> -->
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Summary Report:" prop="file2" :rules="[{ required: (majorProjectLevel && majorProjectLevel !== 4), message: 'Please upload' }]">
                <el-upload
                  class="upload-demo"
                  action="#"
                  :http-request="value => changeFile(value, 'fileList2', 12)"
                  :file-list="fileList2"
                  :show-file-list="false"
                  :before-upload="value => beforeUpload(value)"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :before-remove="beforeRemove"
                  v-model="closeForm.file2"
                >
                  <el-button size="small" type="primary" :disabled="!canEdit">Upload</el-button>
                </el-upload>
                <div class="el-upload-newlist">
                  <div v-for="(item, index) in fileList2" :key="index" class="el-upload-file-box">
                    <a class="file-name" @click="handlePreview(item)"><i class="el-icon-document" />{{ item.name }}</a>
                    <label>
                      <span class="percentage" v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100">{{ item.uploadPercentage }}%</span>
                      <i class="el-icon-circle-check icon-check" style="color: #67c23a" v-if="item.id || item.uploadPercentage === 100"></i>
                      <i class="el-icon-close icon-close" style="display: none" @click="handleRemove('fileList2', 'cancelUploadfile2')"></i>
                    </label>
                    <el-progress v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100" :show-text="false" :stroke-width="2" :percentage="item.uploadPercentage"></el-progress>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          <!-- </el-row>
          <el-row v-if="closeType === 1">
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Scope Statement:" prop="file3" :rules="[{ required: true, message: 'Please upload' }]">
                <el-upload
                  class="upload-demo"
                  :before-upload="value => beforeUpload(value, 13, 'fileList3')"
                  :limit="1"
                  :file-list="fileList3"
                  :on-remove=" value => handleRemove('fileList3')"
                  :before-remove="beforeRemove"
                  :on-exceed="handleExceed"
                  :on-preview="handlePreview"
                  v-model="closeForm.file3"
                >
                  <el-button size="small" type="primary" :disabled="!canEdit">Upload</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Initiation Communication Document:" prop="file4" :rules="[{ required: true, message: 'Please upload' }]">
                <el-upload
                  class="upload-demo"
                  :before-upload="value => beforeUpload(value, 14, 'fileList4')"
                  :limit="1"
                  :file-list="fileList4"
                  :on-remove=" value => handleRemove('fileList4')"
                  :before-remove="beforeRemove"
                  :on-exceed="handleExceed"
                  :on-preview="handlePreview"
                  v-model="closeForm.file4"
                >
                  <el-button size="small" type="primary" :disabled="!canEdit">Upload</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="closeType === 1">
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Management Plan:" prop="file5" :rules="[{ required: true, message: 'Please upload' }]">
                <el-upload
                  class="upload-demo"
                  :action="this.$store.state.islhurl + 'projectFile/upload'"
                  :before-upload="value => beforeUpload(value, 15, 'fileList5')"
                  :limit="1"
                  :file-list="fileList5"
                  :on-remove=" value => handleRemove('fileList5')"
                  :before-remove="beforeRemove"
                  :on-exceed="handleExceed"
                  :on-preview="handlePreview"
                  v-model="closeForm.file5"
                >
                  <el-button size="small" type="primary" :disabled="!canEdit">Upload</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Progress Report:" prop="file6" :rules="[{ required: true, message: 'Please upload' }]">
                <el-upload
                  class="upload-demo"
                  :action="this.$store.state.islhurl + 'projectFile/upload'"
                  :before-upload="value => beforeUpload(value, 16, 'fileList6')"
                  :limit="1"
                  :file-list="fileList6"
                  :on-remove=" value => handleRemove('fileList6')"
                  :before-remove="beforeRemove"
                  :on-exceed="handleExceed"
                  :on-preview="handlePreview"
                  v-model="closeForm.file6"
                >
                  <el-button size="small" type="primary" :disabled="!canEdit">Upload</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="closeType === 1"> -->
            <el-col :xs="24" :md="12">
              <el-form-item label="Information Security Commitment:" prop="file7" :rules="[{ required: (majorProjectLevel && majorProjectLevel !== 4), message: 'Please upload' }]">
                <el-upload
                  class="upload-demo"
                  action="#"
                  :http-request="value => changeFile(value, 'fileList7', 17)"
                  :file-list="fileList7"
                  :show-file-list="false"
                  :before-upload="value => beforeUpload(value)"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :before-remove="beforeRemove"
                  v-model="closeForm.file7"
                >
                  <el-button size="small" type="primary" :disabled="!canEdit">Upload</el-button>
                </el-upload>
                <div class="el-upload-newlist">
                  <div v-for="(item, index) in fileList7" :key="index" class="el-upload-file-box">
                    <a class="file-name" @click="handlePreview(item)"><i class="el-icon-document" />{{ item.name }}</a>
                    <label>
                      <span class="percentage" v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100">{{ item.uploadPercentage }}%</span>
                      <i class="el-icon-circle-check icon-check" style="color: #67c23a" v-if="item.id || item.uploadPercentage === 100"></i>
                      <i class="el-icon-close icon-close" style="display: none" @click="handleRemove('fileList7', 'cancelUploadfile7')"></i>
                    </label>
                    <el-progress v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100" :show-text="false" :stroke-width="2" :percentage="item.uploadPercentage"></el-progress>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row> 
          <el-row> 
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Engineering Transfer Maintenance Document:" prop="file8" :rules="[{ required: (majorProjectLevel && majorProjectLevel !== 4), message: 'Please upload' }]">
                <el-upload
                  class="upload-demo"
                  action="#"
                  :http-request="value => changeFile(value, 'fileList8', 18)"
                  :file-list="fileList8"
                  :show-file-list="false"
                  :before-upload="value => beforeUpload(value)"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :before-remove="beforeRemove"
                  v-model="closeForm.file8"
                >
                  <el-button size="small" type="primary" :disabled="!canEdit">Upload</el-button>
                </el-upload>
                <div class="el-upload-newlist">
                  <div v-for="(item, index) in fileList8" :key="index" class="el-upload-file-box">
                    <a class="file-name" @click="handlePreview(item)"><i class="el-icon-document" />{{ item.name }}</a>
                    <label>
                      <span class="percentage" v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100">{{ item.uploadPercentage }}%</span>
                      <i class="el-icon-circle-check icon-check" style="color: #67c23a" v-if="item.id || item.uploadPercentage === 100"></i>
                      <i class="el-icon-close icon-close" style="display: none" @click="handleRemove('fileList8', 'cancelUploadfile8')"></i>
                    </label>
                    <el-progress v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100" :show-text="false" :stroke-width="2" :percentage="item.uploadPercentage"></el-progress>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :md="12">
              <el-form-item label="Project Closed Remark:" prop="projectClosedRemark" :rules="[{ required: false, message: 'Please input' }]">
                <el-input type="textarea" clearable v-model="closeForm.projectClosedRemark" :disabled="!canEdit" maxlength="200" :rows="3" placeholder="Please input" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div style="text-align: center; padding-top: 10px" v-if="majorProjectLevel && canEdit">
      <el-button type="primary" size="small" :loading="confirmLoading" @click="confirmClose">Confirm</el-button>
    </div>
    <div style="text-align: center; padding-top: 10px" v-if="majorProjectLevel && page === 'toDo'">
      <el-button type="primary" size="small" @click="closeDetail">Return</el-button>
    </div>
    <!-- <div style="text-align: center; padding-top: 10px" v-if="canEditCus">
      <el-button type="primary" size="small" :loading="confirmLoading" @click="confirmRestart">Restart the satisfaction survey</el-button>
      <el-tooltip class="item" effect="dark" content="If you receive a mail indicating that the satisfaction survey failed to send, please update your mailbox address and then click to restart the satisfaction survey." placement="top-start">
        <i class="el-icon-question icon-label" style="font-size: 18px" />
      </el-tooltip>
    </div> -->
  </div>
</template>
<script>
  import moment from 'moment';
  import axios from 'axios';
  export default {
    name: 'projectClose',
		props: {
			id: {
        type: Number,
        default: null,
      },
      projectManagerAllList: {
				type: Array,
        default: [],
			},
			page: {
				type: String,
        default: '',
			},
			keyInfo: {
				type: Object,
        default: {},
			}
		},
    created () {
      // this.getManager();
    },
		watch: {
			projectManagerAllList(newValue, oldValue) {
				this.projectManagerList = newValue;
        if(this.closeForm.projectManager) {
          this.searchManager('projectManagerList', this.closeForm.projectManager)
        }
			}
		},
    data () {
      return {
        moment,
        majorProjectLevel: '',
        closeType: 1,
        activeNames: ['1', '2', '3', '4', '5', '6'],
        closeForm: {
          projectDuration: [],
          satisfactionSurveyFlag: true,
        },
        marketUserList: [],
        projectManagerList: [],
        developmentLeaderList: [],
        riskData: [],
        thisWeekData: [{}],
        nextWeekData: [{}],
        fileList1: [],
        fileList2: [],
        fileList3: [],
        fileList4: [],
        fileList5: [],
        fileList6: [],
        fileList7: [],
        fileList8: [],
        confirmLoading: false,
        canEdit: true,
        approvalprocessing: false,
        alldata: {},
        yesOrNo: [
          {
            name: 'Yes',
            value: 1,
          },
          {
            name: 'No',
            value: 0,
          }
        ],
        yesOrNoBo: [
          {
            name: 'Yes',
            value: true,
          },
          {
            name: 'No',
            value: false,
          }
        ],
        canEditCus: true,
        cancelUploadfile2: null,
        cancelUploadfile7: null,
        cancelUploadfile8: null,
      }
    },
    methods: {
      validateEmail(rule, value, callback) {
        const rule1 = /^([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,14}$/;
        const rule2 = /^[a-zA-Z0-9._@-]+$/;
        if (!value) {
          // 如果非必填且值为空，直接通过（如果需要必填，由 required 规则处理）
          callback();
          return;
        }
        // 检查是否符合 rule1 和 rule2
        if (!rule1.test(value) || !rule2.test(value)) {
          callback(new Error('Invalid mail'));
        } else {
          callback(); // 验证通过
        }
      },
      setData(data) {
        console.log('data', data)
        this.alldata = data;
        this.majorProjectLevel = data.majorProjectLevel;
        this.closeForm.projectName = data.projectName;
        if(data.majorProjectLevel !== 4) {
          this.closeForm.projectDuration = data.projectPlanStartDate ? [moment(data.projectPlanStartDate).format('YYYY-MM-DD'), moment(data.projectPlanEndDate).format('YYYY-MM-DD')] : [];
        } else if (data.majorProjectLevel === 4) {
          this.closeForm.satisfactionSurveyFlag = false
        }
        if(data.canEdit && data.canEdit === 'no') {
          // 待办进入
          this.canEdit = false;
          if(data.flowType === 7) {
            this.closeType = 2;
          }
          this.getDetail();
        } else if(data.projectStatus === 5) {
          // 项目查询进来是已关闭
          this.canEdit = false;
          if(data.majorProjectLevel === 4) {
            this.getDetail(); // 代表初级
          } else {
            let url =`${this.$store.state.islhurl}majorProjectClose/getCloseType?majorProjectId=${this.id}&&islhToken=${sessionStorage.getItem('islhtoken')}`;
            let params = {
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url, params).then(
              res => {
                if(res.code === 200){
                  if(res.data.urlResult === 'getCompanyFormData') {
                    this.getDetail(8);
                  } else if(res.data.urlResult === 'getExceptionData') {
                    this.getDetail(7);
                  }
                }
              }
            )
          }
        } else if(data.page == "detail" ) {
          // 详情进来 查询状态 是否在审批中  8是关闭审批中  7是例外关闭审批中
          this.getStatus(8)
        } 
        if (data.page == "detail") {
          this.$emit('setCloseType', this.closeType)
        }
      },
      getDetail(type) {
        const data = this.alldata;
        let url =`${this.$store.state.islhurl}majorProjectClose/getCompanyFormData?majorProjectId=${(data.majorProjectId || this.id)}&&islhToken=${sessionStorage.getItem('islhtoken')}`
        if(data.majorProjectLevel !== 4 && (data.flowType === 8 || type === 8)) {
          url = `${this.$store.state.islhurl}majorProjectClose/getCompanyFormData?majorProjectId=${(data.majorProjectId || this.id)}&&islhToken=${sessionStorage.getItem('islhtoken')}`
        } else if(data.majorProjectLevel !== 4 && (data.flowType === 7 || type === 7)) {
          url = `${this.$store.state.islhurl}majorProjectClose/getExceptionData?majorProjectId=${(data.majorProjectId || this.id)}&&islhToken=${sessionStorage.getItem('islhtoken')}`
          this.closeType = 2;
        }
        if (this.page === 'projectDetail') {
          this.$emit('setCloseType', this.closeType)
        }
        this._post(url).then(
          res => {
            if(res.code === 200) {
              this.closeForm = {
                ...res.data,
                projectName: res.data.majorProjectName,
                projectDuration: res.data.projectStartDate ? [moment(res.data.projectStartDate).format('YYYY-MM-DD'), moment(res.data.projectEndDate).format('YYYY-MM-DD')] : [],
              }
              if(res.data.marketPersonnelNo) {
                this.remoteMethod('marketUserList', res.data.marketPersonnelNo)
              }
              if(res.data.projectManager) {
                this.searchManager('projectManagerList', res.data.projectManager)
              }
              res.data.projectFiles && res.data.projectFiles.forEach(item => {
                if(item.fileType === 12) this.fileList2 = [{ name: item.fileName, ...item, }];
                if(item.fileType === 17) this.fileList7 = [{ name: item.fileName, ...item, }];
                if(item.fileType === 18) this.fileList8 = [{ name: item.fileName, ...item, }];
              })
            }
          }
        )
      },
      closeDetail() {
        this.$emit('closeDetail')
      },
      // getManager() {
			// 	let url2 =`${this.$store.state.islhurl}majorProjectManager/fuzzyQueryByName?empName=`;
			// 	let params = {
			// 		islhToken : sessionStorage.getItem('islhtoken'),
			// 	}
			// 	this._post(url2, params).then(
			// 		res => {  
			// 			if(res) {
			// 				this.projectManagerList = res
			// 				this.projectManagerAllList = res
			// 			}
			// 		}
			// 	)
      // },
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			searchManager(list, query) {
				if (query !== '') {
					const filterTimeout = setTimeout(() => {
						this[list] = this.projectManagerAllList.filter(item => {
							return item.empCode.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.empName.toLowerCase().indexOf(query.toLowerCase()) > -1;
						});
						clearTimeout(filterTimeout);
					}, 200);
				} else {
					this[list] = [];
				}
			},
      changeMarketUser(value) {
        if(value.trim() === '') {
          this.closeForm.marketPersonnelName = '';
        } else {
          const selectedOption = this.marketUserList.find(option => option.empCode === value);
          this.closeForm.marketPersonnelName = selectedOption.empName;
        }
      },
      openHistoryDialog() {
        this.$refs.historyDialog.historyDialog = true;
      },
      openRecipientDialog() {
        this.$refs.recipientDialog.recipientDialog = true;
      },
			beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 200;
        if (!isLt2M) {
          this.$message.error('File cannot be larger than 200MB!');
          return false;
        }
      },
			changeFile(row, fileList, type) {
				const file = row.file;
				let fd = new FormData();
				fd.append('file', file);
				let params = {
          fileType: type,
          projectId: this.id,
					islhToken: sessionStorage.getItem("islhtoken"),
				}
        fd.append('fileParam', new Blob([JSON.stringify(params)], {type: 'application/json'}));
        let url = `${this.$store.state.islhurl}projectFile/upload`
				// 创建 CancelToken
				const CancelToken = axios.CancelToken;
				const source = CancelToken.source();
				let number = fileList.slice(8);
        console.log(number)
				this['cancelUploadfile' + number] = source.cancel; // 存储取消函数
				this._post(url, fd, {
					cancelToken: source.token, // 绑定 CancelToken
					onUploadProgress: (percent) => {
						this[fileList] = [{
							name: file.name,
							uid: file.uid,
							uploadPercentage: percent === 100 ? 99 : percent,
						}];
						// 通知Upload组件内部进度更新
					},
					noProgress: true // 禁用全局NProgress
				}).then(res => {
					if(res.code == 200) {
						this[fileList] = [{
							name: file.name,
							uid: file.uid,
							id: res.data,
							fileId: res.data,
							uploadPercentage: 100,
						}];
            this.closeForm = {
              ...this.closeForm,
              ['file' + number]: file,
            };
					} else {
						this[fileList] = [];
						this.$message.error(res.message || 'Failed!' );
					}
				}).catch(error => {
					console.log(error)
					this[fileList] = [];
				})
      },
      beforeRemove() {
				if(!this.canEdit) {
					return false;
				}
      },
      handleExceed() {
        this.$message.warning('Only one file is allowed for upload.');
      },
			handlePreview(row) {
				if(row.fileAliasName && row.fileName) {
          window.open(`${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(row.fileAliasName)}&fileName=${encodeURIComponent(row.fileName)}`);
        }
			},
			handleRemove(name, cancelUpload) {
				if(!this.canEdit) {
					return false;
				}
				if (typeof this[cancelUpload] === 'function') {
					this[cancelUpload]('User canceled upload');
					this[cancelUpload] = null;
				}
				this.editForm = {
					...this.editForm,
					file: []
				};
        this[name] = [];
        let number = name.slice(8);
        this.closeForm = {
          ...this.closeForm,
          ['file' + number]: []
        };
			},
			getStatus(type) {
				let url =`${this.$store.state.islhurl}majorProjectFlow/statusCheck?majorProjectId=${this.id}&&flowType=${type}`;
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				this._post(url, params).then(
					res => {
						if(res.code === 200) {
              this.canEdit = false;
              this.approvalprocessing = true;
              this.getDetail(type);
						} else if(type === 8 && this.alldata.majorProjectLevel !== 4) {
              // 没有关闭审批中并且是公司级的  再次查询是否在例外关闭审批中
              this.getStatus(7);
            }
					}
				)
			},
      confirmClose() {
        this.$refs.closeForm.validate((valid) => {
					if (valid) {
            if(this.keyInfo.progressRatio !== 100 && this.alldata.majorProjectLevel !== 4 && this.closeType === 1) {
              this.$message.error('The overall delivery progress of the project has not yet reached 100%');
              return false;
            }
            let params = {
              ...this.closeForm,
              majorProjectId: this.id,
					    islhToken: sessionStorage.getItem('islhtoken'),
					    eosToken: sessionStorage.getItem('eostoken'),
            }
						let url;
            if(this.closeType === 1) {
              url =`${this.$store.state.islhurl}majorProjectClose/closedCompany`;
              params.majorProjectSummaryReport = this.fileList2 && this.fileList2.length > 0 ? this.fileList2[0].id : '';
              params.informationSecurityCommitment = this.fileList7 && this.fileList7.length > 0 ? this.fileList7[0].id : '';
              params.majorProjectHandoverToMaintenance = this.fileList8 && this.fileList8.length > 0 ? this.fileList8[0].id : '';
              params.systemProjectName = params.projectName;
              params.projectStartDate = params.projectDuration && params.projectDuration.length > 0 ? moment(params.projectDuration[0]).format('YYYY-MM-DD HH:mm:ss'): undefined;
              params.projectEndDate = params.projectDuration && params.projectDuration.length > 0 ? moment(params.projectDuration[1]).format('YYYY-MM-DD HH:mm:ss') : undefined;
              delete params.projectName;
              delete params.file2;
              delete params.file7;
              delete params.file8;
              delete params.projectDuration;
              const newparams = { ...params };
              params = new FormData();
						  params.append('closedParams', new Blob([JSON.stringify(newparams)], {type: 'application/json'}))
            } else {
              params.projectStartDate = params.projectDuration && params.projectDuration.length > 0 ? moment(params.projectDuration[0]).format('YYYY-MM-DD HH:mm:ss') : undefined;
              params.projectEndDate = params.projectDuration && params.projectDuration.length > 0 ? moment(params.projectDuration[1]).format('YYYY-MM-DD HH:mm:ss') : undefined;
              url =`${this.$store.state.islhurl}majorProjectClose/exceptionClosed`;
            }
						this.confirmLoading = true;
						this._post(url, params).then(
							res => {
                this.confirmLoading = false;
								if(res.code === 200) {
									this.$Message.success('Successful!' );
                  this.canEdit = false;
                  this.approvalprocessing = true;
                  if(this.majorProjectLevel === 4) {
                    this.getDetail();
                  } else if(this.closeType === 1) {
                    this.getDetail(8);
                  } else {
                    this.getDetail(7);
                  }
								} else {
									this.$message.error(res.message || res.msg || 'Failed!' );
								}
							}
						)
					}
				});
      },
    },
  }
</script>
<style lang="less" scoped>
#projectClose {
	.hiddenBorder {
		box-shadow: none;
		border: none;
	}
	.el-form {
		padding: 20px 0;
		/deep/.el-input {
			max-width: 350px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 12px;
		}
		/deep/.el-input-number {
			width: 100%;
			.el-input__inner {
				text-align: left;
			}
		}
    /deep/.el-upload-list__item.is-success.focusing .el-icon-close-tip {
			display: none !important;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
			max-width: 350px;
		}
    /deep/.el-textarea {
      max-width: 350px;
    }
    /deep/.el-range-editor.is-disabled input {
      color: #606266;
    }
    /deep/.el-textarea.is-disabled .el-textarea__inner {
      color: #606266;
    }
    /deep/.el-date-editor .el-range-input {
      font-size: 12px;
    }
    /deep/.el-date-editor .el-range__icon {
      line-height: 24px;
    }
	}
  .star {
    color: #F56C6C;
    padding-left: 1px;
  }
}
.el-upload-newlist {
	width: 300px;
	.el-upload-file-box {
		margin-top: 10px;
		border-radius: 4px;
		position: relative;
		line-height: 26px;
		.file-name {
			line-height: 26px;
			color: #606266;
			display: block;
			margin-right: 40px;
			overflow: hidden;
			padding-left: 4px;
			text-overflow: ellipsis;
			-webkit-transition: color .3s;
			transition: color .3s;
			white-space: nowrap;
			i {
				margin-right: 7px;
    		color: #909399;
			}
		}
		.file-name:hover {
			color: #409eff;
		}
		label {
			position: absolute;
			right: 5px;
			top: 0;
			line-height: inherit;
			i {
				line-height: 26px;
			}
			.icon-close {
				cursor: pointer;
			}
			.percentage {
				color: #666;
				font-size: 12px;
			}
		}
	}
	.el-upload-file-box:hover {
		background-color: #f5f7fa;
		.icon-check, .percentage {
			display: none;
		}
		.icon-close {
			display: block !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/projectClose/index.vue